import { render, staticRenderFns } from "./BrokerFirmOrderEdit.vue?vue&type=template&id=445c0923&scoped=true"
import script from "./BrokerFirmOrderEdit.vue?vue&type=script&lang=js"
export * from "./BrokerFirmOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c0923",
  null
  
)

export default component.exports